import React from "react";
import { Box, Typography, Button, Grid, Container } from "@mui/material";
import workdesk from '../assets/images/workdesk.webp';

const Banner = () => {
  return (
    <Box
      sx={{
        position: "relative",
        backgroundImage: `linear-gradient(rgba(0, 119, 182, 0.8), rgba(0, 180, 216, 0.8)), url(${workdesk})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        padding: { xs: "20px 10px", sm: "60px 20px" },
        textAlign: "center",
        color: "#fff",
        minHeight: { xs: "100vh", md: "calc(100vh - 200px)" }, // Adjust height for mobile
        display: "flex",
        alignItems: "center",
      }}
    >
      <Container>
        <Grid
          container
          spacing={4}
          justifyContent="center"
          sx={{
            flexDirection: { xs: "column", md: "row" },
            position: "relative",
          }}
        >
          <Grid item xs={12} md={10} sx={{ position: "relative", zIndex: 1 }}>
            <Typography
              variant="h4"
              sx={{
                fontWeight: "bold",
                color: "transparent",
                backgroundImage: "linear-gradient(to right, #ffffff, #d9e3f0)",
                backgroundClip: "text",
                WebkitBackgroundClip: "text",
                fontSize: { xs: "1.8rem", sm: "2.5rem", md: "3rem" },
                textTransform: "uppercase",
                marginBottom: { xs: "15px", sm: "20px" },
                letterSpacing: "2px",
                lineHeight: 1.2,
                textShadow: "1px 1px 3px rgba(0, 0, 0, 0.2)",
              }}
            >
              Empowering the Future of <br />
              <Typography
                component="span"
                sx={{
                  color: "transparent",
                  backgroundImage: "linear-gradient(to right, #ffffff, #d9e3f0)",
                  backgroundClip: "text",
                  WebkitBackgroundClip: "text",
                  fontWeight: "bold",
                  fontSize: "inherit",
                }}
              >
                Technology Innovation
              </Typography>
            </Typography>

            <Typography
              variant="body1"
              sx={{
                color: "#ffffff",
                marginBottom: "20px",
                fontWeight: "bold",
                fontSize: { xs: "1rem", sm: "1.2rem", md: "1.6rem" },
                lineHeight: 1.5,
                opacity: 0.9,
                padding: { xs: "0 10px", sm: "0 20px" },
              }}
            >
              We believe in transforming ideas into reality. With our cutting-edge
              solutions, we help businesses thrive in a digital-first world. Let’s
              unlock new possibilities together!
            </Typography>

            <Button
              variant="contained"
              sx={{
                backgroundColor: "#0077b6",
                color: "#ffffff",
                padding: "12px 24px",
                fontWeight: "bold",
                fontSize: { xs: "0.9rem", sm: "1rem", md: "1.2rem" },
                "&:hover": {
                  backgroundColor: "#005f82",
                },
              }}
              href="#journey"
            >
              Start Your Journey
            </Button>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Banner;
